<app-italo-ecu-logo></app-italo-ecu-logo>

<div id="about-us">
    <h1>Über uns</h1>
</div>

<app-language-switcher></app-language-switcher>
<app-navigation></app-navigation>
